// test api
// export const baseUrl = "https://api.singspire.com.ng/api";

// local api
// export const baseUrl = "http://127.0.0.1:8000/api";

// production api
export const baseUrl = "https://guardianhealth-patient.crestpath.ng/api";